import { isBirdieGameType, isCrashGameType } from 'src/utils/gameTypeUtils'

export type BoardKind = 'crash' | 'birdie' | 'chip-placement' | 'classic'

/**
 * The DOM class of the slot page.tsx renders inside `.dolby-feed`, next to
 * <LiveStream>. The board portals its desktop overlay in there so the overlay's
 * DOM parent is the video box (and not the CSS-transform-scaled bottom column),
 * while the component tree — and therefore the chip state — stays in one place.
 */
export const BIRDIE_ARC_SLOT_CLASS = 'birdie-arc-slot'

/**
 * Which betting surface a game gets. Pure so the "a classic game never gets the
 * Birdie board" guarantee is a test rather than a reading of page.tsx's ternary
 * chain (there is no render suite in this repo).
 *
 * Order matters: crash first (it owns the whole frame), then Birdie (whose
 * config still says `chip-placement`, because seven other surfaces gate on it),
 * then the shared chip panel, then the classic panel.
 */
export function boardFor(input: { gameType?: string; bettingMode?: string }): BoardKind {
  const gameType = input.gameType ?? ''
  if (isCrashGameType(gameType)) return 'crash'
  if (isBirdieGameType(gameType)) return 'birdie'
  if (input.bettingMode === 'chip-placement') return 'chip-placement'
  return 'classic'
}
